// extracted by mini-css-extract-plugin
module.exports = {"icon":"index_icon_3Ltu6","carousel":"index_carousel_1bv-8"};